import SectionHeading from "@/components/base/SectionHeading";
import LaunchOfferSection from "@/components/feature/LaunchOfferSection";
import CtaSection from "@/components/feature/CtaSection";
import HeroSection from "./components/HeroSection";
import ProblemsSection from "./components/ProblemsSection";
import FeaturesSection from "./components/FeaturesSection";
import OwnerShowcaseSection from "./components/OwnerShowcaseSection";
import AgencyShowcaseSection from "./components/AgencyShowcaseSection";
import HowItWorksSection from "./components/HowItWorksSection";
import TestimonialsSection from "./components/TestimonialsSection";
import FaqPreviewSection from "./components/FaqPreviewSection";

export default function Home() {
  return (
    <div className="flex flex-col">
      <HeroSection />
      <ProblemsSection />
      <FeaturesSection />
      <OwnerShowcaseSection />
      <AgencyShowcaseSection />
      <HowItWorksSection />

      <section className="py-16 md:py-24 bg-background-100">
        <div className="container-page">
          <SectionHeading
            eyebrow="Offre de lancement"
            title="6 mois gratuits, accès complet à toutes les fonctionnalités"
            description="Pendant l'offre de lancement, les propriétaires et les agences démarrent sans frais et sans limites de formule."
          />
          <LaunchOfferSection className="mt-10" />
        </div>
      </section>

      <TestimonialsSection />
      <FaqPreviewSection />
      <CtaSection />
    </div>
  );
}